import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ConfigService } from "../../config/config.service";
import { AdvisorData } from "../advisor.model";

@Injectable({
  providedIn: "root",
})
export class AdvisorDataService {
  private readonly advisorsUrl: string;

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) {
    this.advisorsUrl = `${this.configService.environment.advisors?.url}/advisors`;
  }

  get(advisorId: number): Observable<AdvisorData> {
    return this.http.get<AdvisorData>(`${this.advisorsUrl}/${advisorId}`);
  }
}
